import { getParam } from "./index";
import bridge from "./bridge";

export const OPEN_BROWSER = "openBrowser";
export const OPEN_WEBVIEW = "openWebView";
export const CLOSE_WEBVIEW = "closeWebview";

const IS_ANDROID = getParam("devicePlate") === "android";

const TARGET_ACTION_MAP = {
  0: OPEN_WEBVIEW,
  1: OPEN_WEBVIEW,
  2: OPEN_BROWSER,
};

export const sdkCloseWebview = (): void => {
  if (IS_ANDROID) {
    window.sdkCtrl.closeWebview();
  } else {
    bridge.callSdkMethod(CLOSE_WEBVIEW);
  }
};
/**
 * link:打开链接
 * openWay: 打开方式 openWebView/openBrowser
 * loginDir：是否需要登录 1:是 0:否
 * appendParams：是否要带sdk参数 1:是 0:否
 * source: 来源
 */
export const sdkOpenLink = ({
  link,
  openWay = 0,
  loginDir = "1",
  appendParams = "1",
  source = "",
}) => {
  if (!link) {
    return;
  }
  goLinkPoint(link, source);
  const openWayType = TARGET_ACTION_MAP[openWay];
  if (bridge.runInsdk()) {
    bridge.callSdkMethod(openWayType, {
      url: link,
      loginDir: loginDir,
      appendParams: appendParams,
    });
    return;
  }
  const openPageWay = openWayType === OPEN_WEBVIEW ? "_self" : "_blank";
  let openLink = link;
  if (!appendParams) {
    window.open(openLink, openPageWay);
    return;
  }
  if (link.indexOf("?") > -1) {
    let search = window.location.search.substring(1);
    openLink = link + "&" + search;
    window.open(openLink, openPageWay);
    return;
  }
  window.open(openLink + window.location.search, openPageWay);
};
